import React, { useState, useEffect } from 'react';
import { Button, Modal, Switch } from 'antd';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: fixed;
  bottom: 10px;
  left: 0;
  margin: 20px;
  background-color: #ffffff;
  padding: 15px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  border-radius: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
  }
`;

const BannerText = styled.span`
  color: #333;
  font-size: 14px;

  @media (max-width: 600px) {
    margin-bottom: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
  }
`;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(
      'cookieConsent',
      JSON.stringify({ necessary: true, analytics: true, marketing: true })
    );
    setVisible(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    setVisible(false);
    setModalVisible(false);
  };

  return (
    <>
      {visible && (
        <BannerContainer>
          <BannerText style={{marginRight: '20px'}}>
            Vi bruker informasjonskapsler for å forbedre din opplevelse. Ved å
            fortsette godtar du vår bruk av {' '}
            <a href="/cookie" style={{ color: '#230518', textDecoration: 'underline' }}>
              informasjonskapsler
            </a>
          </BannerText>
          <ButtonContainer>
            <Button
              type="primary"
              onClick={handleAcceptAll}
              style={{ backgroundColor: '#230518', width: "100%" }}
            >
              Aksepter alle
            </Button>
            <Button
              style={{
                borderColor: "#dfdfdf",
                color: "#230518",
                width: "100%"
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#15524F")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#dfdfdf")}
              onClick={() => setModalVisible(true)}
            >
              Administrer innstillinger
            </Button>
          </ButtonContainer>
        </BannerContainer>
      )}

      <Modal
        title="Administrer informasjonskapsler"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleSavePreferences}
        okText="Lagre valg"
        cancelText="Avbryt"
        okButtonProps={{
          style: { backgroundColor: "#230518", borderColor: "#230518" },
        }}
        cancelButtonProps={{
          style: {
            borderColor: "#fffaf8",
            color: "#230518",
          },
          onMouseEnter: (e) => {
            e.currentTarget.style.borderColor = "#230518";
          },
          onMouseLeave: (e) => {
            e.currentTarget.style.borderColor = "#dfdfdf";
          },
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Nødvendige informasjonskapsler</span>
            <div style={{ position: "relative", display: "inline-block" }}>
              <Switch
                checked={true}
                disabled
                style={{
                  backgroundColor: "#230518",
                  cursor: "not-allowed",
                  opacity: 0.8,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255,255,255,0.3)",
                  borderRadius: "15px",
                  pointerEvents: "none",
                }}
              />
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Analyseinformasjonskapsler</span>
            <Switch
              checked={preferences.analytics}
              onChange={(checked) => setPreferences({ ...preferences, analytics: checked })}
              style={{
                backgroundColor: preferences.analytics ? "#230518" : "",
              }}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Markedsføringsinformasjonskapsler</span>
            <Switch
              checked={preferences.marketing}
              onChange={(checked) => setPreferences({ ...preferences, marketing: checked })}
              style={{
                backgroundColor: preferences.marketing ? "#230518" : "",
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CookieBanner;